import translate from "@insite/client-framework/Translate";
import React, { FC } from "react";
import {
    InstructionsBox,
    UploadLayout,
    UploadLeft,
    UploadRight,
} from "@dana/Components/DanaOrderUpload/DanaOrderUploadStyledComponents";
import siteMessage from "@insite/client-framework/SiteMessage";
import TextArea from "@insite/mobius/TextArea";

interface Props {
    pasteText: string;
    onChange: (value: string) => void;
    isEmea?: boolean;
}

const DanaOrderUploadStep1Paste: FC<Props> = ({ pasteText, onChange, isEmea }) => {

    const PASTE_PLACEHOLDER = isEmea
        ? translate(
            "Examples:\n\nTab\n5-2031X\t23\t15/06/2026\n\nComma\n5-2031X,23,15/06/2026\n\nPipe\n5-2031X|23|15/06/2026") :
        "Examples:\n\nTab\n5-2031X\t23\t06/15/2026\n\nComma\n5-2031X,23,06/15/2026\n\nPipe\n5-2031X|23|06/15/2026";
    const dateFormat = isEmea ? "DD/MM/YYYY" : "MM/DD/YYYY";
    return (
        <UploadLayout>
            <UploadLeft>
                <TextArea
                    label={translate("Part No.(Tab/Comma/Pipe)Qty(Tab/Comma/Pipe)Req. Ship Date (" + dateFormat + ")")}
                    value={pasteText}
                    onChange={e => onChange(e.target.value)}
                    onKeyDown={e => {
                        if (e.key === "Tab") {
                            e.preventDefault();
                            const el = e.currentTarget as HTMLTextAreaElement;
                            const start = el.selectionStart;
                            const end = el.selectionEnd;
                            onChange(pasteText.substring(0, start) + "\t" + pasteText.substring(end));
                            requestAnimationFrame(() => {
                                el.selectionStart = el.selectionEnd = start + 1;
                            });
                        }
                    }}
                    placeholder={PASTE_PLACEHOLDER}
                    data-test-selector="danaOrderUpload_pasteArea"
                />
            </UploadLeft>
            <UploadRight>
                <InstructionsBox>
                    {siteMessage("Dana_WishList_PartUpload_AddToListCopyPasteModalInstructions")}
                </InstructionsBox>
            </UploadRight>
        </UploadLayout>
    )

};

export default DanaOrderUploadStep1Paste;
